import { Course, Level, Issue } from '../../types'

interface CoursesState {
  activeCourses: Array<Course>
  currentCourse: Course
  currentLevels: Array<Level>
  courseRating: object
  currentCourseProgress: object
  contentIssues: Array<object> | null
  currentIssue: Issue
  courseRatingModalOpened: Boolean
}

const state = {
  activeCourses: [],
  currentCourse: {
    id: '',
    name: '',
    content: [],
    user_status: null,
  },
  currentLevels: [],
  courseRating: {},
  currentCourseProgress: {},
  contentIssues: null,
  currentIssue: {
    subject: '',
    comment: '',
    course_id: null,
    content_type: '',
    content_subtype: '',
    content_id: null,
    extra_args: {
      /*
        // Fields expected by content type
        "video_player_time": 0,
        "video_player_status": "started",
        "iframe_cdn_url": "http://iframe-cdn-url.com/123",
        "quiz_question_id": "8345fc0e-91c2-43b3-a768-c347c9caf485",
        "azure_lab_github_url": "http://azure-lab-github-url.com/123",
        "els_lab_id": "8345fc0e-91c2-43b3-a768-c347c9caf485",
        "els_lab_status": "started",
        "els_lab_session_id": "8345fc0e-91c2-43b3-a768-c347c9caf485",
        "student_code": "def hello_world()"
      */
    },
  },
  courseRatingModalOpened: false,
}

export { CoursesState, state }
